"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

require("./image.less");

var Image = function (_super) {
  __extends(Image, _super);

  function Image(props) {
    var _this = _super.call(this, props) || this;

    if ("string" === typeof props.content) {
      _this.state = {
        imageURL: props.content
      };
    } else {
      _this.state = {
        imageURL: ""
      };

      if (props.content instanceof File || props.content instanceof Blob) {
        _this.loadFileAsDataURL(props.content);
      }
    }

    return _this;
  }

  Image.prototype.componentWillReceiveProps = function (nextProps) {
    if ("string" === typeof nextProps.content) {
      this.setState({
        imageURL: nextProps.content
      });
    } else {
      this.setState({
        imageURL: ""
      });

      if (nextProps.content instanceof File || nextProps.content instanceof Blob) {
        this.loadFileAsDataURL(nextProps.content);
      } else if (nextProps.content instanceof Blob) {
        var reader = new FileReader();
        reader.readAsDataURL(nextProps.content);
      }
    }
  };

  Image.prototype.loadFileAsDataURL = function (file) {
    var _this = this;

    var reader = new FileReader();

    reader.onload = function (e) {
      var target = e.target;

      _this.setState({
        imageURL: target.result
      });
    };

    reader.readAsDataURL(file);
  };

  Image.prototype.render = function () {
    var classNames = ["image"];

    if ("" === this.state.imageURL) {
      classNames.push("empty");
    }

    return React.createElement("div", {
      className: classNames.join(" "),
      "data-x-aspect-ratio": this.props.aspectRatio
    }, React.createElement("div", {
      style: {
        backgroundImage: "url(" + this.state.imageURL + ")"
      }
    }), this.props.children);
  };

  return Image;
}(React.Component);

exports["default"] = Image;

function Overlay(props) {
  var classNames = ["mask"];

  if (props.hoverOnly) {
    classNames.push("hoveronly");
  }

  var onClick = function onClick(event) {
    if (props.onClick) {
      props.onClick(event);
    }
  };

  return React.createElement("div", {
    className: classNames.join(" "),
    onClick: onClick
  }, React.createElement("div", {
    className: "shade",
    style: {
      background: props.color || "#000",
      opacity: props.opacity || 0.5
    }
  }), props.children);
}

exports.Overlay = Overlay;